export enum ForecastPeriod {
  Daily = 'Tomorrow',
  Weekly = 'Next Week',
  Monthly = 'Next Month',
  Yearly = 'Next Year',
  Custom = 'Custom'
}
